import { useTranslation } from '@framework/i18n';
import { Button, ButtonProps } from 'antd';
import React from 'react';

export interface IInquiryFilterRemoveButtonProps extends ButtonProps {}

/**
 * Pulsante per azzerare i filtri di ricerca delle domande.
 */
export function InquiryFilterRemoveButton(
  props: IInquiryFilterRemoveButtonProps,
) {
  const { t } = useTranslation();

  return (
    <Button
      children={t(
        'domande.lista.pulsante.rimuovi-filtri',
        'Rimuovi filtri',
      )}
      {...props}
    />
  );
}
